// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>15</span>&nbsp;&nbsp;That they may show that the Lord is true;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;he is my rock,<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;and there is no unrighteousness in him.<br> </p> </div></div>";
// Exports
module.exports = code;